<template>
    <div
        ref="lazyImage"
        :title="alt || title"
        :style="imageStyles"
        class="lazy-image"
    >
        <a :href="link" v-if="link" class="link"></a>
    </div>
</template>

<script>
export default {
    props: {
        imageSrc: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        link: {
            type: String,
            default: "",
        },
        styles: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            imageStyles: {
                backgroundImage: "", // Initial empty background
            },
        };
    },
    mounted() {
        this.loadImage();
    },
    methods: {
        loadImage() {
            // Check if the browser supports WebP
            const webpSupported = this.supportsWebP();

            // Modify image source if WebP is supported
            const imageUrl = webpSupported
                ? this.imageSrc.replace(/\.(jpe?g|png)$/i, ".webp")
                : this.imageSrc;

            // Set the background image dynamically
            this.imageStyles.backgroundImage = `url(${imageUrl})`;
        },
        supportsWebP() {
            // Check WebP support
            const elem = document.createElement("canvas");

            if (!!(elem.getContext && elem.getContext("2d"))) {
                return (
                    elem.toDataURL("image/webp").indexOf("data:image/webp") ===
                    0
                );
            }
            return false;
        },
    },
};
</script>

<style scoped>
.lazy-image {
    width: 100%;
    /* height: 100%; */
    background-size: cover;
    background-position: center;
}

.link {
    display: block;
    width: 100%;
    height: 100%;
}
</style>
